(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["locations-accordion"] && !Shopify.designMode) return;
  try {
    
  function initLocationsAccordion(container = document) {

    /* ---------- Swiper ---------- */
    container.querySelectorAll(".locations-swiper").forEach(swiperEl => {
      if (swiperEl.swiper) return; // prevent double init

      new Swiper(swiperEl, {
        slidesPerView: "auto",
        spaceBetween: 10,
        freeMode: true,
        grabCursor: true,
        observer: true,
        observeParents: true
      });
    });

    /* ---------- Accordion ---------- */
    container.querySelectorAll('[data-accordion-trigger]').forEach(trigger => {
      if (trigger.dataset.bound === "true") return;
      trigger.dataset.bound = "true";

      trigger.addEventListener('click', () => {
        const content = trigger.nextElementSibling;
        const icon = trigger.querySelector('[data-accordion-icon]');
        const isOpen = content.classList.contains('open');

        // Close all
        container.querySelectorAll('[data-accordion-content]').forEach(c => {
          c.classList.remove('open');
          c.style.maxHeight = null;
        });
        container.querySelectorAll('[data-accordion-icon]').forEach(i => {
          i.textContent = '+';
        });

        // Open current
        if (!isOpen) {
          content.classList.add('open');
          content.style.maxHeight = content.scrollHeight + "px";
          icon.textContent = "−";

          content.querySelectorAll('video').forEach(v => v.play());
        }
      });
    });
  }

  /* Run on first load */
  initLocationsAccordion();

  /* Run when Shopify reloads the section (theme editor / dynamic load) */
  document.addEventListener('shopify:section:load', (event) => {
    initLocationsAccordion(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nested-accordion"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  
  const openAccordion = (content, icon) => {
    content.classList.add('open');
    content.style.maxHeight = content.scrollHeight + "px";
    if(icon) icon.textContent = "−";
  };

  const closeAccordion = (content, icon) => {
    content.classList.remove('open');
    content.style.maxHeight = null;
    if(icon) icon.textContent = "+";
  };

  // Handle Level 1 (Parent)
  document.querySelectorAll('.acc-parent__trigger').forEach(trigger => {
    trigger.addEventListener('click', function() {
      const content = this.nextElementSibling;
      const icon = this.querySelector('[data-icon]');
      const isOpen = content.classList.contains('open');

      // Close others
      document.querySelectorAll('.acc-parent__content').forEach(c => {
        c.classList.remove('open');
        c.style.maxHeight = null;
        c.previousElementSibling.querySelector('[data-icon]').textContent = '+';
      });

      if (!isOpen) openAccordion(content, icon);
    });
  });

  // Handle Level 2 (Child)
  document.querySelectorAll('.acc-child__trigger').forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      
      const content = this.nextElementSibling;
      const icon = this.querySelector('[data-icon]');
      const isOpen = content.classList.contains('open');
      
      const parentWrapper = this.closest('.acc-child__wrapper');
      
      // Close siblings only
      parentWrapper.querySelectorAll('.acc-child__content').forEach(c => {
        c.classList.remove('open');
        c.style.maxHeight = null;
        c.previousElementSibling.querySelector('[data-icon]').textContent = '+';
      });

      if (!isOpen) {
        openAccordion(content, icon);
        // Resize parent
        const grandParentContent = this.closest('.acc-parent__content');
        if(grandParentContent) grandParentContent.style.maxHeight = "none"; 
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {

    // 1. Accordion Logic (Fixed)
const accordions = document.querySelectorAll('.accordion');
accordions.forEach(function(acc) {
  acc.addEventListener('click', function() {
    this.classList.toggle('active');
    const panel = this.nextElementSibling;
    if (!panel) return;

    // Use the inner content to calculate height
    const inner = panel.querySelector('.panel-inner');
    if (!inner) return;

    if (panel.style.maxHeight && panel.style.maxHeight !== "0px") {
      panel.style.maxHeight = "0px"; // collapse
    } else {
      panel.style.maxHeight = inner.scrollHeight + "px"; // expand
    }
  });
});


    // 2. Mobile Sticky Purchase Toggle
     const toggleBtn = document.getElementById('MobileStickyToggle');
const stickyContainer = document.getElementById('MobileStickyPurchase');
const purchaseContent = document.getElementById('MobileStickyContent');

if (toggleBtn && stickyContainer && purchaseContent) {
  ['click', 'touchstart'].forEach(evt => {
    toggleBtn.addEventListener(evt, function(e) {
      e.preventDefault();
      stickyContainer.classList.toggle('expanded');

      if (stickyContainer.classList.contains('expanded')) {
        purchaseContent.style.maxHeight = purchaseContent.scrollHeight + "px";
      } else {
        purchaseContent.style.maxHeight = "0px";
      }
    });
  });
}


    // 3. Sync Main Price to Mobile Sticky Price
    // This finds the main product info column and watches for ANY change in it.
    // When a change happens (like a price update from the theme), it copies the new price text to mobile.
    const productInfoColumn = document.querySelector('.product-information__info');
    const mobilePriceTarget = document.getElementById('MobilePriceTarget');

    const mainPriceSource = productInfoColumn.querySelector('.price-item--regular, .price__current, .product-price, .price .price-item, product-price');
        
    if(mainPriceSource) {
        mobilePriceTarget.innerHTML = mainPriceSource.innerHTML;
    }

    if(productInfoColumn && mobilePriceTarget) {
      const observer = new MutationObserver(function(mutations) {
        // Find the main price element. We try a few common class names used in Shopify themes.
        const mainPriceSource = productInfoColumn.querySelector('.price-item--regular, .price__current, .product-price, .price .price-item, product-price');
        
        if(mainPriceSource) {
           mobilePriceTarget.innerHTML = mainPriceSource.innerHTML;
        }
      });

      // Watch for changes in the product info column
      observer.observe(productInfoColumn, { 
        childList: true, 
        subtree: true, 
        characterData: true 
      });
    }

  });

  } catch(e) { console.error(e); }
})();
})();
